import getConfig from 'next/config';

import {ContentTypes} from '~/src/types/content';
import {postApiRequest} from '~/src/utilities/feed/api';
import {Logger} from '~/src/utilities/helpers/log';
import {userIsLoggedIn} from '~/src/utilities/helpers/account';

const {publicRuntimeConfig: config} = getConfig();
const tenantId = parseInt(config.tenantId, 10);

interface QueryParams {
    action: 'visit';
    contentId: number;
    contentType: ContentTypes;
}

export const trackEvent = (queryParams: QueryParams) => {
    const data = {
        tenantId,
        ...queryParams
    };

    if (userIsLoggedIn()) {
        postApiRequest(config.analytics.service.persist, data).catch((error) =>
            Logger.info(`[${error.name}][helper/analytics] Error while persisting action ${queryParams.action}`, {error})
        );
    }
};
